import { z } from '../zod';

export const CUSTOMER_ORIGIN_KINDS = [
  'link_in_bio',
  'payment',
  'booking',
  'subscription',
  'submission',
] as const;

export const CustomerOriginResponseValidationSchema = z
  .object({
    origin: z
      .object({
        kind: z.enum(CUSTOMER_ORIGIN_KINDS),
        createdAt: z.date(),
        recordId: z.string().nullable(),
        pageTitle: z.string().nullable(),
      })
      .nullable(),
  })
  .meta({ id: 'CustomerOrigin' });

export type CustomerOriginResponse = z.infer<typeof CustomerOriginResponseValidationSchema>;
